import { A3Badge } from './a3';
import { ChallengeTags } from './challenge';
import { UploadedFile } from './common';
import { Company, CompanyMember } from './company';
import { Region } from './region';
import { Topic } from './topic';

export enum UserRole {
  ADMIN = 'ADMIN',
  INTRAPRENEUR = 'INTRAPRENEUR',
  COACH = 'COACH',
  PANEL_MEMBER = 'PANEL_MEMBER',
  CHALLENGE_MANAGER = 'CHALLENGE_MANAGER',
  EXTERNAL_USER = 'EXTERNAL_USER',
}

export interface Role {
  displayName: string;
  id: number;
  name: string;
}

export interface Education {
  createdAt: string;
  degree: string;
  deletedAt: string;
  endDate: string;
  id: number;
  logo: UploadedFile;
  logoData: string;
  school: string;
  startDate: string;
  updatedAt: string;
  user: User;
  userId: number;
}

export interface Experience {
  company: Company;
  companyName: string;
  createdAt: string;
  current: boolean;
  description: string;
  endDate: string;
  id: number;
  logo: UploadedFile;
  logoData: string;
  startDate: string;
  title: string;
  updatedAt: string;
  user: User;
}

export interface Skill {
  id: number;
  name: string;
  rootId: number;
  __typename: string;
}

export interface Profile {
  id: number;
  linkedin: string;
  location: string;
  facebook: string;
  instagram: string;
  medium: string;
  twitter: string;
  phone: string;
  title: string;
  shortBio: string;
  talkToMeAbout: string;
  profileCategories: string[];
  user: User;
  website: string;
  createdAt: string;
  updatedAt: string;
  socialHidden: boolean;
  businessAreas: string[];
}

export interface User {
  accountType?: string;
  balance?: number;
  createdAt?: string;
  currentPositions?: CompanyMember[];
  topics?: Topic[];
  regions?: Region[];
  educations?: Education[];
  email?: string;
  experiences?: Experience[];
  firstName?: string;
  fullName: string;
  id: number;
  image?: UploadedFile;
  imageData?: string;
  lastName?: string;
  position?: string;
  profile?: Profile;
  reviewerType?: string;
  role?: string;
  skills?: Skill[];
  updatedAt?: string;
  verified?: boolean;
  companies?: Company[];
  rank?: Rank;
  emailHidden?: boolean;
  badge?: A3Badge[];
  psid?: string;
  permissions?: Permission[];
  badgeRequest?: {
    id: string;
  };
}

export interface PublicUser {
  id: number;
  fullName?: string;
  email?: string;
  title?: string;
  image?: UploadedFile;
}
export interface UserPermission {
  id: string;
  user: User;
  permission: Permission;
  resourceId: string;
}
export interface Permission {
  id: string;
  name: string;
  type: string;
  resource: {
    id: string;
    name: string;
  };
}

export interface UpdateInterests {
  updateInterests: User;
}

export interface privateAllUsers {
  id: number;
  fullName: string;
  email: string;
  image: {
    url: string;
  };
  role: string;
  permissions: string[];
}

export interface Me {
  id: number;
  isAdmin: boolean;
  fullName: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  emailHidden: boolean;
  image: {
    url: string;
    id: string;
  };
  permissions: string[];
  country: string;
  regions: Region[];
  topics: Topic[];
  skills: Skill[];
  profile?: Profile;
  notificationSettings?: {
    emailNotificationCodes?: number[];
    inAppNotificationCodes?: number[];
  };
  rank: Rank;
  companies: Company[];
  authToken: string;
  badge?: A3Badge[];
  bundles?: ChallengeTags[];
  badgeRequest: {
    id: string;
  };
}

export interface RuleHistory {
  id: string;
  userId: User;
  point: number;
  createdAt: Date;
  rule: string;
  ruleId: string;
}

export interface RuleHistoryWithTotal {
  items: RuleHistory[];
  total: number;
}
export interface Rank {
  rank: number;
  badge: Badge;
}
export interface Badge {
  name: string;
  startPoint: number;
  endPoint: number;
  level: number;
  id: string;
}
export interface UpdateProfile {
  id: string;
  firstName: string;
  lastName: string;
  image: {
    url: string;
  };
  emailHidden: boolean;
  profile: {
    location: string;
    linkedin: string;
    facebook: string;
    twitter: string;
    shortBio: string;
    website: string;
    socialHidden: boolean;
  };
}

export interface DownloadAllUsers {
  downloadEmailList: string;
}

export interface DownloadAllUsersPointList {
  downloadUserPointList: string;
}

export interface DownloadAllUsersA3PointList {
  downloadA3PointList: string;
}

export interface DiscoverUser {
  id: number;
  firstName: string;
  lastName: string;
  image: string;
  location: string;
  title: string;
  verified: boolean;
}
